import { render, staticRenderFns } from "./ResourcePanel.vue?vue&type=template&id=182d211a&scoped=true"
import script from "./ResourcePanel.vue?vue&type=script&lang=js"
export * from "./ResourcePanel.vue?vue&type=script&lang=js"
import style0 from "./ResourcePanel.vue?vue&type=style&index=0&id=182d211a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d211a",
  null
  
)

export default component.exports